<template>
  <div
    v-if="(!rightShow && contentWidth >= 1550) || (!rightShow && !leftShow)"
    class="wyc_list_btn"
  >
    <div class="btn l" v-if="!wycShow" @click="setHearderControl(4)">
      <i class="icons saveDoc"></i><span>保存文章</span>
    </div>
    <div
      class="btn g"
      v-if="!wycShow"
      @click="setHearderControl(1)"
      style="margin-bottom: 20px"
    >
      <i class="icons newDoc"></i><span>新建文章</span>
    </div>

    <el-popover placement="left" popper-class="importStyle" trigger="click">
      <div>
        <p @click="importFiles(1)">文件导入</p>
        <p @click="importFiles(2)">链接导入</p>
      </div>
      <div v-show="!wycShow" slot="reference" class="btn m">
        <i class="icons importDoc"></i><span>导入文章</span>
      </div>
    </el-popover>

    <div v-if="!wycShow" class="btn a" @click="setHearderControl(3)">
      <i class="icons phonePreview"></i><span>手机预览</span>
    </div>
    <div v-if="!wycShow" class="btn o" @click="setHearderControl(5)">
      <i class="icons longPic"></i><span>生成长图</span>
    </div>
    <div
      v-if="!wycShow"
      style="margin-bottom: 20px"
      class="btn c"
      @click="copy()"
    >
      <i class="icons copy"></i><span>一键复制</span>
    </div>

    <div class="btn g" v-if="editorShow" @click="showWycTip(true)">
      <i class="icons original"></i>
      智能原创
    </div>
    <div class="btn c btnSentence" v-if="wycShow" @click="showWycBox(false)">
      <i class="icons editor"></i>
      编辑文章
    </div>
    <div class="btn i" v-if="!wycShow" @click="getfun('整句原创')">
      <i class="icons paragraph"></i><span>整句原创</span>
    </div>
    <div v-if="wycShow" class="btn g" @click="getfun('智能换词')">
      <i class="icons originalNew"></i><span>智能换词</span>
    </div>
    <div v-if="wycShow" class="btn h" @click="getfun('智能改写')">
      <i class="icons importDoc"></i><span>智能改写</span>
    </div>
    <div class="btn b" @click="getfun('智能标题')">
      <i class="icons title"></i><span>智能标题</span>
    </div>
    <div class="btn j" @click="getfun('智能摘要')">
      <i class="icons abstract"></i><span>智能摘要</span>
    </div>
    <div class="btn d" @click="getfun('智能纠错')">
      <i class="icons error"></i><span>智能纠错</span>
    </div>
    <div class="btn e" @click="getfun('原创检测')">
      <i class="icons check"></i><span>原创检测</span>
    </div>
    <div v-if="!wycShow" class="btn k" @click="getfun('违规检测')">
      <i class="icons Illegal"></i><span>违规检测</span>
    </div>
    <el-dialog
      title="提示信息"
      :visible.sync="lengthCountType"
      width="350px"
      :modal-append-to-body="false"
    >
      <div>
        <span>您当前级别文字内容超出{{ wordsCount }}字</span>
      </div>
      <div>
        <span v-if="userLevel >= 100">可以截取文字内容进行编辑</span
        ><span v-else>可升级会员获取编辑权限，也可以截取文字内容编辑</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="userLevel < 100" class="btnvip" @click="upgrade"
          >升级{{ getUserNextLevel(userLevel) }}</el-button
        >
        <el-button class="btncut" @click="cupWords">自动截取文字</el-button>
      </span>
    </el-dialog>
  </div>
  <div v-else class="wyc_list_ring">
    <!--    <div class="btn" v-if="!wycShow" @click="showWycBox(true)">-->
    <!--      <div class="btn1 ba">伪</div>-->
    <!--    </div>-->
    <!--    <div class="btn" v-if="wycShow" @click="showWycBox(false)">-->
    <!--      <div class="btn1 ba">编</div>-->
    <!--    </div>-->
    <div
      class="btn l"
      v-show="!isSave"
      v-if="!wycShow"
      @mouseleave="isSave = true"
      @mouseenter="isSave = false"
      @click="setHearderControl(4)"
    >
      <i class="icons saveDoc"></i><span>保存文章</span>
    </div>
    <div
      class="btn2"
      v-if="!wycShow"
      v-show="isSave"
      @mouseleave="isSave = true"
      @mouseenter="isSave = false"
      @click="setHearderControl(4)"
    >
      <i class="icons saveDoc1"></i>
    </div>
    <div
      class="btn g"
      v-if="!wycShow"
      v-show="!isNewDoc"
      @mouseleave="isNewDoc = true"
      @mouseenter="isNewDoc = false"
      @click="setHearderControl(1)"
      style="margin-bottom: 20px"
    >
      <i class="icons newDoc"></i><span>新建文章</span>
    </div>
    <div
      class="btn2"
      v-if="!wycShow"
      v-show="isNewDoc"
      @mouseenter="isNewDoc = false"
      @mouseleave="isNewDoc = true"
      @click="setHearderControl(1)"
      style="margin-bottom: 20px"
    >
      <i class="icons newDoc1"></i>
    </div>
    <el-popover placement="left" popper-class="importStyle" trigger="click">
      <div>
        <p @click="importFiles(1)">文件导入</p>
        <p @click="importFiles(2)">链接导入</p>
      </div>
      <div
        slot="reference"
        class="btn m"
        v-show="!isImport && !wycShow"
        @mouseleave="isImport = true"
        @mouseenter="isImport = false"
      >
        <i class="icons importDoc"></i><span>导入文章</span>
      </div>
      <div
        slot="reference"
        class="btn2"
        v-show="!wycShow && isImport"
        @mouseenter="isImport = false"
        @mouseleave="isImport = true"
      >
        <i class="icons importDoc1"></i>
      </div>
    </el-popover>
    <!--    <el-popover placement="left" popper-class="importStyle" trigger="click">-->
    <!--      <div>-->
    <!--        <p @click="importFiles(1)">文件导入</p>-->
    <!--        <p @click="importFiles(2)">链接导入</p>-->
    <!--      </div>-->
    <!--      -->
    <!--    </el-popover>-->
    <div
      class="btn a"
      v-if="!wycShow"
      v-show="!isPhone"
      @mouseleave="isPhone = true"
      @mouseenter="isPhone = false"
      @click="setHearderControl(3)"
    >
      <i class="icons phonePreview"></i><span>手机预览</span>
    </div>
    <div
      class="btn2"
      v-if="!wycShow"
      v-show="isPhone"
      @mouseleave="isPhone = true"
      @mouseenter="isPhone = false"
      @click="setHearderControl(3)"
    >
      <i class="icons phonePreview1"></i>
    </div>
    <div
      class="btn o"
      v-if="!wycShow"
      v-show="!isLongPic"
      @mouseleave="isLongPic = true"
      @mouseenter="isLongPic = false"
      @click="setHearderControl(5)"
    >
      <i class="icons longPic"></i><span>生成长图</span>
    </div>
    <div
      class="btn2"
      v-if="!wycShow"
      v-show="isLongPic"
      @mouseleave="isLongPic = true"
      @mouseenter="isLongPic = false"
      @click="setHearderControl(5)"
    >
      <i class="icons longPic1"></i>
    </div>

    <div
      v-if="!wycShow"
      v-show="!isCopy"
      @mouseleave="isCopy = true"
      @mouseenter="isCopy = false"
      class="btn c"
      @click="copy()"
      style="margin-bottom: 20px"
    >
      <i class="icons copy"></i><span>一键复制</span>
    </div>
    <div
      v-if="!wycShow"
      v-show="isCopy"
      @mouseleave="isCopy = true"
      @mouseenter="isCopy = false"
      class="btn2"
      style="margin-bottom: 20px"
      @click="copy()"
    >
      <i class="icons copy1"></i>
    </div>

    <!--    <div class="btn" v-if="!wycShow" @click="showWycBox(true)">-->
    <!--      <div class="btn1 ba">伪</div>-->
    <!--    </div>-->
    <!--    <div class="btn" v-if="wycShow" @click="showWycBox(false)">-->
    <!--      <div class="btn1 ba">编</div>-->
    <!--    </div>-->
    <div
      class="btn c btnSentence"
      v-if="wycShow"
      v-show="!isEditor"
      @mouseenter="isEditor = false"
      @mouseleave="isEditor = true"
      @click="showWycBox(false)"
    >
      <i class="icons editor"></i><span>编辑文章</span>
    </div>
    <div
      class="btn2 btnSentence"
      v-if="wycShow"
      v-show="isEditor"
      @mouseleave="isEditor = true"
      @mouseenter="isEditor = false"
      @click="showWycBox(false)"
    >
      <i class="icons editor1"></i>
    </div>
    <div
      v-if="wycShow"
      class="btn g"
      v-show="!isChangeWords"
      @mouseenter="isChangeWords = false"
      @mouseleave="isChangeWords = true"
      @click="getfun('智能换词')"
    >
      <i class="icons originalNew"></i><span>智能换词</span>
    </div>
    <div
      class="btn2"
      v-if="wycShow"
      v-show="isChangeWords"
      @mouseleave="isChangeWords = true"
      @mouseenter="isChangeWords = false"
      @click="showWycBox(true)"
    >
      <i class="icons originalNew1"></i>
    </div>
    <div
      v-if="wycShow"
      class="btn h"
      v-show="!isSentence"
      @mouseenter="isSentence = false"
      @mouseleave="isSentence = true"
      @click="getfun('智能改写')"
    >
      <i class="icons importDoc"></i><span>智能改写</span>
    </div>
    <div
      class="btn2"
      v-if="wycShow"
      v-show="isSentence"
      @mouseleave="isSentence = true"
      @mouseenter="isSentence = false"
      @click="showWycBox(true)"
    >
      <i class="icons importDoc1"></i>
    </div>
    <div
      class="btn g"
      v-if="!wycShow"
      v-show="!isOriginal"
      @mouseenter="isOriginal = false"
      @mouseleave="isOriginal = true"
      @click="showWycTip(true)"
    >
      <i class="icons original"></i><span>智能原创</span>
    </div>
    <div
      class="btn2"
      v-if="!wycShow"
      v-show="isOriginal"
      @mouseleave="isOriginal = true"
      @mouseenter="isOriginal = false"
      @click="showWycTip(true)"
    >
      <i class="icons original1"></i>
    </div>

    <div
      class="btn i"
      v-if="!wycShow"
      v-show="!isParagraph"
      @mouseenter="isParagraph = false"
      @mouseleave="isParagraph = true"
      @click="getfun('整句原创')"
    >
      <i class="icons paragraph"></i><span>整句原创</span>
    </div>
    <div
      class="btn2"
      v-if="!wycShow"
      v-show="isParagraph"
      @mouseleave="isParagraph = true"
      @mouseenter="isParagraph = false"
      @click="getfun('整句原创')"
    >
      <i class="icons paragraph1"></i>
    </div>
    <div
      class="btn b"
      v-show="!isTitle"
      @mouseenter="isTitle = false"
      @mouseleave="isTitle = true"
      @click="getfun('智能标题')"
    >
      <i class="icons title"></i><span>智能标题</span>
    </div>
    <div
      class="btn2"
      v-show="isTitle"
      @mouseleave="isTitle = true"
      @mouseenter="isTitle = false"
      @click="getfun('智能标题')"
    >
      <i class="icons title1"></i>
    </div>
    <div
      class="btn j"
      v-show="!isAbstract"
      @mouseenter="isAbstract = false"
      @mouseleave="isAbstract = true"
      @click="getfun('智能摘要')"
    >
      <i class="icons abstract"></i><span>智能摘要</span>
    </div>
    <div
      class="btn2"
      v-show="isAbstract"
      @mouseleave="isAbstract = true"
      @mouseenter="isAbstract = false"
      @click="getfun('智能摘要')"
    >
      <i class="icons abstract1"></i>
    </div>
    <div
      class="btn d"
      v-show="!isNewError"
      @mouseenter="isNewError = false"
      @mouseleave="isNewError = true"
      @click="getfun('智能纠错')"
    >
      <i class="icons error"></i><span>智能纠错</span>
    </div>
    <div
      class="btn2"
      v-show="isNewError"
      @mouseleave="isNewError = true"
      @mouseenter="isNewError = false"
      @click="getfun('智能纠错')"
    >
      <i class="icons error1"></i>
    </div>
    <div
      class="btn e"
      v-show="!isCheck"
      @mouseenter="isCheck = false"
      @mouseleave="isCheck = true"
      @click="getfun('原创检测')"
    >
      <i class="icons check"></i><span>原创检测</span>
    </div>
    <div
      class="btn2"
      v-show="isCheck"
      @mouseleave="isCheck = true"
      @mouseenter="isCheck = false"
      @click="getfun('原创检测')"
    >
      <i class="icons check1"></i>
    </div>
    <div
      v-if="!wycShow"
      v-show="!isNewIllegal"
      @mouseenter="isNewIllegal = false"
      @mouseleave="isNewIllegal = true"
      class="btn k"
      @click="getfun('违规检测')"
    >
      <i class="icons Illegal"></i><span>违规检测</span>
    </div>
    <div
      v-if="!wycShow"
      class="btn2"
      v-show="isNewIllegal"
      @mouseleave="isNewIllegal = true"
      @mouseenter="isNewIllegal = false"
      @click="getfun('违规检测')"
    >
      <i class="icons Illegal1"></i>
    </div>
    <!--    <div class="btn" v-if="wycShow" @click="getfun('句式重构')">-->
    <!--      <div class="btn1 bh">句</div>-->
    <!--    </div>-->

    <el-dialog
      title="提示信息"
      :visible.sync="lengthCountType"
      width="350px"
      :modal-append-to-body="false"
    >
      <div>
        <span>您当前级别文字内容超出{{ wordsCount }}字</span>
      </div>
      <div>
        <span v-if="userLevel >= 100">可以截取文字内容进行编辑</span
        ><span v-else>可升级会员获取编辑权限，也可以截取文字内容编辑</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="userLevel < 100" class="btnvip" @click="upgrade"
          >升级{{ getUserNextLevel(userLevel) }}</el-button
        >
        <el-button class="btncut" @click="cupWords">自动截取文字</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tinymce from "tinymce";
// import ShowMessage from "./ShowMessage";
import { SendPostData } from "../../assets/script/model";
import { mapActions, mapMutations, mapState } from "vuex";
import findWords from "../../assets/script/utils/findWords";

export default {
  name: "WycListBtn",
  data() {
    return {
      content: "",
      lengthCountType: false,
      wordsCount: 0,
      showBoxType: false,
      typeName: "",
      // contentWidth: 0,
      isTitle: true,
      isOriginal: true,
      isAbstract: true,
      isNewError: true,
      isCheck: true,
      isNewIllegal: true,
      isCopy: true,
      isSave: true,
      isLongPic: true,
      isPhone: true,
      isImport: true,
      isNewDoc: true,
      isParagraph: true,
      isEditor: true,
      isSentence: true,
      isChangeWords: true,
      oldOpenWycNum: 0
    };
  },
  // components: {
  //   ShowMessage
  // },
  computed: {
    ...mapState("user", ["userLevel", "userToken"]),
    ...mapState("wycContent", ["isShow"]),
    ...mapState("contents", ["showMessageBox", "headerFun", "importFile"]),
    editorShow: {
      get() {
        return this.$store.state.contents.editorShow;
      },
      set(val) {
        this.$store.state.contents.editorShow = val;
      }
    },
    wycShow: {
      get() {
        return this.$store.state.contents.wycShow;
      },
      set(val) {
        this.$store.state.contents.wycShow = val;
      }
    },
    wycContent: {
      get() {
        return this.$store.state.wycContent.wycContent;
      },
      set(val) {
        this.$store.state.wycContent.wycContent = val;
      }
    },
    rightTitle: {
      get() {
        return this.$store.state.contents.rightTitle;
      },
      set(val) {
        this.$store.state.contents.rightTitle = val;
      }
    },
    rightShow: {
      get() {
        return this.$store.state.contents.rightShow;
      },
      set(val) {
        this.$store.state.contents.rightShow = val;
      }
    },
    leftShow: {
      get() {
        return this.$store.state.contents.leftShow;
      },
      set(val) {
        this.$store.state.contents.leftShow = val;
      }
    },
    sendCount: {
      get() {
        return this.$store.state.wycContent.sendCount;
      },
      set(val) {
        this.$store.state.wycContent.sendCount = val;
      }
    },
    allContent: {
      get() {
        return this.$store.state.wycContent.allContent;
      },
      set(val) {
        this.$store.state.wycContent.allContent = val;
      }
    },
    contentWidth: {
      get() {
        return this.$store.state.contents.contentWidth;
      },
      set(val) {
        this.$store.state.contents.contentWidth = val;
      }
    },
    sentence: {
      get() {
        return this.$store.state.editorControl.sentence;
      },
      set(val) {
        this.$store.state.editorControl.sentence = val;
      }
    }
  },
  mounted() {
    this.listenMessage();
  },
  methods: {
    ...mapActions("api", ["APermission"]),
    ...mapMutations("wycContent", ["setIsShow"]),
    ...mapMutations("contents", [
      "setShowMessage",
      "setShowBtn",
      "setShowTitle",
      "setShowMessageBox",
      "setHeaderFun",
      "setImportFile",
      "setWycShowMsg"
    ]),
    listenMessage() {
      window.addEventListener("message", function(e) {
        if (e.data && e.data.cmd === "_5118_Response_Message_Content") {
          if (!e.data.isclose && e.data.btn === "gettxt") {
            tinymce.activeEditor.setContent(e.data.data.txt);
            tinymce.activeEditor.focus();
          }
        }
      });
    },
    showLongBtn() {
      // let dom = document.getElementsByClassName("original")[0];
    },
    setHearderControl(val) {
      this.setHeaderFun(val);
    },
    importFiles(val) {
      if (val === 1) {
        if (this.userToken === "") {
          this.insertConfig.showLoginMessage(
            true,
            "您当前账号暂未登录，请登录账号享更多权限",
            "save"
          );
          return;
        }
        this.setImportFile(val);
        // if (this.userLevel >= 100) {
        //   this.importShowBox = false;
        //   this.setImportFile(val);
        // } else {
        //   this.importShowBox = false;
        //   this.insertConfig.showUpgrade(true, "升级获得使用权");
        // }
      } else {
        this.setImportFile(val);
      }
    },
    showWycTip(type) {
      if (type) {
        const getShowTip = JSON.parse(localStorage.getItem("wycShowTip"));
        if (getShowTip) {
          if (getShowTip.isCheck && getShowTip.checkType) {
            this.showWycBox(true);
          } else {
            this.setWycShowMsg(true);
          }
        } else {
          this.setWycShowMsg(true);
        }
      }
    },
    async showWycBox(type) {
      if (type) {
        let newcheck = "wycindex";
        let newresult = await this.APermission({ SysName: newcheck });
        if (newresult.errorCode > 0) {
          if (newresult.errorCode === 300000) {
            this.insertConfig.showLoginMessage(
              true,
              "您当前账号暂未登录，请登录账号享更多权限",
              newcheck
            );
          } else {
            this.$message({
              showClose: true,
              message: newresult.errorMess,
              type: "error"
            });
          }
          return;
        }
        if (newresult.data > 0 || newresult.data === -1) {
          let checkName = "wycindexlength";
          let result = await this.APermission({ SysName: checkName });
          if (result.errorCode > 0) {
            this.$message({
              message: result.errorMess,
              type: "error",
              showClose: true
            });
            return;
          }
          let wycTxt = tinymce.activeEditor.getBody().innerText;
          if (wycTxt <= 0) {
            this.$message({
              showClose: true,
              message: "内容不能为空",
              type: "error"
            });
            return;
          }
          this.wordsCount = result.data;
          if (wycTxt.length > this.wordsCount) {
            this.lengthCountType = true;
          } else {
            let sendData = new SendPostData();
            sendData.btn = "send";
            sendData.data = { txt: wycTxt };
            this.SendMessage(sendData);
            this.sendCount = 1;
            let isok = true;
            this.setIsShow(isok);
          }
        } else {
          this.insertConfig.showUpgrade(true, "获取更多使用次数");
          // this.$message({
          //   message: "您的手动智能原创次数已用尽",
          //   type: "error",
          //   showClose: true
          // });
        }
      } else {
        this.rightShow = false;
        this.editorShow = true;
        this.wycShow = false;
        let sendData = new SendPostData();
        this.isEditor = true;
        this.leftShow = true;
        sendData.btn = "finish";
        this.SendMessage(sendData);
      }
    },
    upgrade() {
      this.lengthCountType = false;
      let routeData = this.$router.resolve({ name: "permission" });
      window.open(routeData.href, "_blank");
    },
    cupWords() {
      let wycTxt = tinymce.activeEditor.getBody().innerText;
      wycTxt = wycTxt.substring(0, this.wordsCount);
      this.lengthCountType = false;
      let isok = true;
      this.setIsShow(isok);

      let sendData = new SendPostData();
      sendData.btn = "send";
      sendData.data = { txt: wycTxt };
      this.SendMessage(sendData);
      this.sendCount = 1;
    },
    copy() {
      findWords.closeAllHighlight();
      let copyDom = tinymce.activeEditor.getBody();
      let reg = new RegExp("[a-z0-9A-Z\\u4E00-\\u9FFF]+", "g");
      if (!reg.test(copyDom.innerText)) {
        this.insertConfig.showPrompt(
          true,
          "抱歉，您左侧编辑器中还没有内容正文，请丰富正文后使用该功能"
        );
        return;
      }
      //创建选中范围
      // let range = document.createRange();

      //移除剪切板中内容
      window.getSelection().removeAllRanges();
      //添加新的内容到剪切板
      // window
      //   .getSelection()
      //   .addRange(window.getSelection().selectAllChildren(copyDom));
      window.getSelection().selectAllChildren(copyDom);
      //复制
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      this.$message({
        message: "文章复制成功",
        type: "success",
        showClose: true
      });
    },
    async getfun(title) {
      findWords.closeAllHighlight();
      let checkName = "";
      let copyDom = tinymce.activeEditor.getBody().innerText;
      if (title === "整句原创") {
        checkName = "wyctranslate";
        let text = window._getSelectText;
        if (!text) {
          this.setShowMessageBox(true);
          this.setShowMessage(
            "您可通过手动划词来进行智能原创，划词不能超过300字符"
          );
          this.setShowTitle("提示信息");
          this.setShowBtn("去划词使用");
          return;
        }
        if (this.Trim(text).length <= 300) {
          this.sentence = this.Trim(text);
        } else {
          this.$message({
            showClose: true,
            message: "整句智能原创不能超过300字符",
            type: "warning "
          });
          return;
        }
        // checkName = "wycakeyanalyze";
      }
      if (title === "智能标题") {
        checkName = "wycarticletitle";
        if (copyDom.length < 200) {
          this.insertConfig.showPrompt(
            true,
            "抱歉，您左侧编辑器中的内容正文长度少于200个汉字，请丰富正文后使用该功能"
          );
          return;
        }
      }
      if (title === "智能摘要") {
        checkName = "wycabstract";
        if (copyDom.length < 200) {
          this.insertConfig.showPrompt(
            true,
            "抱歉，您左侧编辑器中的内容正文长度少于200个汉字，请丰富正文后使用该功能"
          );
          return;
        }
      }
      if (title === "智能纠错") {
        checkName = "wycdetection";
        let reg = new RegExp("[a-z0-9A-Z\\u4E00-\\u9FFF]+", "g");
        if (!reg.test(copyDom)) {
          this.insertConfig.showPrompt(
            true,
            "抱歉，您左侧编辑器中还没有内容正文，请丰富正文后使用该功能"
          );
          return;
        }
      }
      if (title === "原创检测") {
        checkName = "wycoriginalfull";
        let reg = new RegExp("[a-z0-9A-Z\\u4E00-\\u9FFF]+", "g");
        if (!reg.test(copyDom)) {
          this.insertConfig.showPrompt(
            true,
            "抱歉，您左侧编辑器中还没有内容正文，请丰富正文后使用该功能"
          );
          return;
        }
      }
      if (title === "违规检测") {
        checkName = "illegaltextcheck";
        let reg = new RegExp("[a-z0-9A-Z\\u4E00-\\u9FFF]+", "g");
        if (!reg.test(copyDom)) {
          this.insertConfig.showPrompt(
            true,
            "抱歉，您左侧编辑器中还没有内容正文，请丰富正文后使用该功能"
          );
          return;
        }
      }
      if (title === "智能改写") {
        checkName = "wycakeyanalyze";
        let reg = new RegExp("[a-z0-9A-Z\\u4E00-\\u9FFF]+", "g");
        if (!reg.test(copyDom)) {
          this.insertConfig.showPrompt(
            true,
            "抱歉，您左侧编辑器中还没有内容正文，请丰富正文后使用该功能"
          );
          return;
        }
      }
      if (title === "智能换词") {
        checkName = "wycakeyanalyze";
        let reg = new RegExp("[a-z0-9A-Z\\u4E00-\\u9FFF]+", "g");
        if (!reg.test(copyDom)) {
          this.insertConfig.showPrompt(
            true,
            "抱歉，您左侧编辑器中还没有内容正文，请丰富正文后使用该功能"
          );
          return;
        }
      }
      let result = await this.APermission({ SysName: checkName });
      if (result.errorCode > 0) {
        if (result.errorCode === 300000) {
          this.insertConfig.showLoginMessage(
            true,
            "您当前账号暂未登录，请登录账号享更多权限",
            checkName
          );
        } else {
          this.$message({
            showClose: true,
            message: result.errorMess,
            type: "error"
          });
        }
        return;
      }
      if (result.data > 0 || result.data === -1) {
        this.rightTitle = title;
        this.rightShow = true;
      } else {
        this.insertConfig.showUpgrade(true, "获取更多使用次数");
        // this.$message({
        //   message: "您的" + title + "次数已用尽",
        //   type: "error",
        //   showClose: true
        // });
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/mixin";
/deep/.el-dialog__headerbtn {
  top: 15px;
}
/deep/.el-dialog__wrapper {
  top: 15%;
}
/deep/.el-dialog__header {
  padding: 10px 20px 10px;
  border-bottom: 1px solid @borderbottom;
}
/deep/.el-dialog__title {
  font-size: 14px;
}
/deep/.el-dialog__footer {
  text-align: center;
}
/deep/.el-dialog__body {
  padding: 15px 15px;
  div {
    &:nth-child(1) {
      text-align: center;
      font-size: 20px;
      color: red;
      margin-bottom: 10px;
    }
    &:nth-child(2) {
      text-align: center;
      font-size: 12px;
    }
  }
}
.btnSentence {
  background-color: #6f49ff !important;
  color: #fff !important;
  border-color: #6f49ff !important;
}
.btnvip {
  .btn();
  padding: 5px 20px 5px 20px;
  border: 0;
}
.btncut {
  .btn();
  background-color: red;
  border: 0;
  padding: 5px 20px 5px 20px;
}
.icons {
  display: inline-block;
  height: 25px;
  width: 25px;
}
.editor {
  background: url("../../assets/image/wyc/editor_ico.png") no-repeat 50%;
  vertical-align: top;
  margin-left: 7px;
}
.editor1 {
  background: url("../../assets/image/wyc/editor_ico.png") no-repeat 50%;
  width: 30px;
  height: 30px;
  position: absolute;
}
.oriedit {
  background: url("../../assets/image/wyc/oriedit_ico.png") no-repeat 50%;
  vertical-align: top;
  margin-left: 7px;
}
.oriedit1 {
  background: url("../../assets/image/wyc/oriedit_ico.png") no-repeat 50%;
  width: 30px;
  height: 30px;
  position: absolute;
}
.title {
  background: url("../../assets/image/wyc/title_ico.png") no-repeat 50%;
  vertical-align: top;
  margin-left: 7px;
}
.title1 {
  background: url("../../assets/image/wyc/title_ico.png") no-repeat 50%;
  width: 30px;
  height: 30px;
  position: absolute;
}
.abstract {
  background: url("../../assets/image/wyc/abstract_ico.png") no-repeat 50%;
  vertical-align: top;
  margin-left: 7px;
}
.abstract1 {
  background: url("../../assets/image/wyc/abstract_ico.png") no-repeat 50%;
  width: 30px;
  height: 30px;
  position: absolute;
}
.check {
  background: url("../../assets/image/wyc/check_ico.png") no-repeat 50%;
  vertical-align: top;
  margin-left: 7px;
}
.check1 {
  background: url("../../assets/image/wyc/check_ico.png") no-repeat 50%;
  width: 30px;
  height: 30px;
  position: absolute;
}
.copy {
  background: url("../../assets/image/wyc/copy_ico.png") no-repeat 50%;
  vertical-align: top;
  margin-left: 7px;
}
.copy1 {
  background: url("../../assets/image/wyc/copy_ico.png") no-repeat 50%;
  width: 30px;
  height: 30px;
  position: absolute;
}
.error {
  background: url("../../assets/image/wyc/error_ico.png") no-repeat 50%;
  vertical-align: top;
  margin-left: 7px;
}
.error1 {
  background: url("../../assets/image/wyc/error_ico.png") no-repeat 50%;
  width: 30px;
  height: 30px;
  position: absolute;
}
.Illegal {
  background: url("../../assets/image/wyc/Illegal_ico.png") no-repeat 50%;
  vertical-align: top;
  margin-left: 7px;
}
.Illegal1 {
  background: url("../../assets/image/wyc/Illegal_ico.png") no-repeat 50%;
  width: 30px;
  height: 30px;
  position: absolute;
}
.original {
  background: url("../../assets/image/wyc/original_ico.png") no-repeat 50%;
  vertical-align: top;
  margin-left: 7px;
}
.original1 {
  background: url("../../assets/image/wyc/original_ico.png") no-repeat 50%;
  width: 30px;
  height: 30px;
  position: absolute;
}
.paragraph {
  background: url("../../assets/image/wyc/paragraph_ico.png") no-repeat 50%;
  vertical-align: top;
  margin-left: 7px;
}
.paragraph1 {
  background: url("../../assets/image/wyc/paragraph_ico.png") no-repeat 50%;
  width: 30px;
  height: 30px;
  position: absolute;
}
.saveDoc {
  background: url("../../assets/image/wyc/save_ico.png") no-repeat 50%;
  vertical-align: top;
  margin-left: 7px;
}
.saveDoc1 {
  background: url("../../assets/image/wyc/save_ico.png") no-repeat 50%;
  width: 30px;
  height: 30px;
  position: absolute;
}
.longPic {
  background: url("../../assets/image/wyc/longPic.png") no-repeat 50%;
  vertical-align: top;
  margin-left: 7px;
}
.longPic1 {
  background: url("../../assets/image/wyc/longPic.png") no-repeat 50%;
  width: 30px;
  height: 30px;
  position: absolute;
}
.importDoc {
  background: url("../../assets/image/wyc/import_ico.png") no-repeat 50%;
  vertical-align: top;
  margin-left: 7px;
}
.importDoc1 {
  background: url("../../assets/image/wyc/import_ico.png") no-repeat 50%;
  width: 30px;
  height: 30px;
  position: absolute;
}
.phonePreview {
  background: url("../../assets/image/wyc/phone_ico.png") no-repeat 50%;
  vertical-align: top;
  margin-left: 7px;
}
.phonePreview1 {
  background: url("../../assets/image/wyc/phone_ico.png") no-repeat 50%;
  width: 30px;
  height: 30px;
  position: absolute;
}
.newDoc {
  background: url("../../assets/image/wyc/newdoc_ico.png") no-repeat 50%;
  vertical-align: top;
  margin-left: 7px;
}
.newDoc1 {
  background: url("../../assets/image/wyc/newdoc_ico.png") no-repeat 50%;
  width: 30px;
  height: 30px;
  position: absolute;
}
.originalNew {
  background: url("../../assets/image/wyc/original_new_ico.png") no-repeat 50%;
  vertical-align: top;
  margin-left: 7px;
}
.originalNew1 {
  background: url("../../assets/image/wyc/original_new_ico.png") no-repeat 50%;
  width: 30px;
  height: 30px;
  position: absolute;
}

.btn1 {
  position: relative;
  border: 0;
  padding: 10px;
  width: 27px;
  height: 27px;
  margin-top: 15px;
  border-radius: 50%;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: 36px 36px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  color: #fff;
  div {
    font-size: 14px;
  }
}
.wyc_list_ring {
  padding: 0 10px;
  position: fixed;
  /*top: 24px;*/
  margin-left: 790px;
  /*float: right;*/
  /*right: 0;*/
  transition: all 0.6s ease-in-out;
  z-index: 1902;
}
.btn2 {
  position: relative;
  border: 0;
  padding: 10px;
  width: 37px;
  height: 37px;
  border-radius: 50%;
  margin-bottom: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px 0 rgba(202, 221, 255, 0.9);
  background-size: 36px 36px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  background-color: #ffffff;
  color: #fff;
}
.wyc_list_btn {
  padding: 0 10px;
  position: fixed;
  top: 24px;
  margin-left: -10px;
  float: right;
  transition: all 0.6s ease-in-out;
  z-index: 1902;
}
.btn {
  padding: 5px 0;
  font-size: 13px;
  font-weight: bolder;
  border: 1px solid #fff;
  width: 110px;
  /*border-radius: 25px;*/
  cursor: pointer;
  line-height: 25px;
  margin-bottom: 7px;
  /*margin: 8px 0;*/
  text-align: left;
  background-color: #ffffff;
  box-shadow: 0 4px 10px 0 rgba(202, 221, 255, 0.9);
  span {
    margin-left: 5px;
    letter-spacing: 1px;
  }
}
.a {
  color: #5c92e3;
}
.b {
  color: #5388f8;
}
.c {
  color: #9464ed;
}
.d {
  color: #fd5d53;
}
.e {
  color: #ecb92f;
}
.f {
  color: #fa6c01;
}
.g {
  color: #2dbf29;
}
.h {
  color: #1aae9d;
}
.i {
  color: #35b2ec;
}
.j {
  color: #3ab19f;
}
.k {
  color: #ea9424;
}
.l {
  color: #6864ed;
}
.m {
  color: #35d1b9;
}
.o {
  color: #cb64ed;
}
</style>

<style lang="less">
.importStyle {
  min-width: 80px !important;
  background-color: #35d1b9;
  font-size: 12px;
  border-radius: 4px;
  color: #fff;
  height: 68px;
  line-height: 20px;
  text-align: center;
  padding: 5px 1px;
  border-color: #35d1b9;
  p {
    padding: 4px 10px;
    color: #fff;
    cursor: pointer;
    &:hover {
      background-color: #26af9a;
    }
  }
}
.importStyle[x-placement^="left"] .popper__arrow::after {
  border-left-color: #35d1b9;
}
</style>
